export default "__VITE_ASSET__8024d9c5__"